const isAllowed = (props) => {
    //console.log(props.children.props.location.pathname);
    document.title = props.pagename;
    
    //console.log(localStorage.getItem("user"));
    if (typeof props.accessType != undefined && props.accessType === 'logedin') {
        if (!localStorage.getItem("user")) {
            window.location.href = '/login';
        }
    } else if (typeof props.accessType != undefined && props.accessType === 'public') {
        if (props.children.props.location.pathname ==='/login' && localStorage.getItem("user")) {
            window.location.href = '/';
        } else if (props.children.props.location.pathname ==='/logout' && !localStorage.getItem("user")) {
            window.location.href = '/login';
        }
    }
}
export { isAllowed };